import { Injectable, NgZone } from "@angular/core";
import { IOrganization, IUser } from "../../@core/models/model";
import { BaseService } from "../../@core/services/base.service";
import { environment } from "../../../environments/environment.dev";
import { HttpClient } from "@angular/common/http";
import { CompareService } from "../components/edit-contract/components/compare/compare.service";

export interface IAuditLog {
    organization: string | IOrganization;
    createdBy: string | Partial<IUser>;
    data: Record<string, string | number | boolean | Date>;
    module: AUDIT_MODULE;
    action: string;
    description: string;
    status: AUDIT_STATUS;
    createdAt: Date;
    updatedAt: Date;
}

export enum AUDIT_MODULE {
    COMPARE = 'COMPARE',
    DOCUMENT = 'DOCUMENT',
    DOCUMENT_FORM = 'DOCUMENT_FORM',
    PROJECTS = 'PROJECTS',
}

export enum AUDIT_STATUS {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    PENDING = 'PENDING',
}

@Injectable({
    providedIn: 'root'
})

export class AuditLogService extends BaseService {
    private url = environment.apiUrl + '/audit-logs'
    constructor(protected override http: HttpClient, protected ngZone: NgZone, private compareService: CompareService) {
        super(http, ngZone);
    }

    getAuditLogs(auditModule: AUDIT_MODULE, filter: Record<string, string> = {}) {
        return this.post<IAuditLog[]>(this.url, { auditModule, filter })
    }

}